import React, { useMemo } from 'react';

// Use the exact same color palette as your Header for consistency
const COLORS = ['#2F855A', '#D69E2E', '#805AD5', '#DD6B20', '#3182CE', '#1E7D6B'];

export default function Userdiv({ reviewCount, targetUser, helpfulVotes, loading }) {
  
  const { bgColor, initial } = useMemo(() => {
    const name = targetUser?.fullname || 'User';
    
    // Exact same math logic as Header.jsx
    const sum = name.split('').reduce((s, char) => s + char.charCodeAt(0), 0);
    const calculatedColor = COLORS[sum % COLORS.length];

    return {
      bgColor: calculatedColor,
      initial: name[0]?.toUpperCase() || 'U'
    };
  }, [targetUser]);

  if (loading || !targetUser) return null;

  const memberSinceYear = targetUser.since ? new Date(targetUser.since).getFullYear() : 'N/A';

  return (
    <div className='w-full max-w-[1224px] mx-auto px-4 sm:px-10 pt-[100px] pb-16 lg:pt-32'>
      <div className='relative w-full bg-greentomoregreen rounded-[20px] sm:rounded-[40px] transform rotate-2 lg:rotate-1 shadow-lg'>
        <div className='relative -rotate-2 lg:-rotate-1 bg-white border border-gray-100 shadow-2xl rounded-[15px] sm:rounded-[30px] p-8 sm:p-12 lg:p-16 transform translate-y-3 sm:translate-y-6'>
          
          <div className='flex flex-col lg:flex-row lg:items-center justify-between gap-10'>
            
            <div className='flex flex-row items-center gap-6 lg:gap-8'>
              {/* Avatar with Synced Background Color */}
              <div 
                className='w-20 h-20 sm:w-28 sm:h-28 lg:w-36 lg:h-36 rounded-2xl flex-shrink-0 flex items-center justify-center text-white font-bold text-3xl sm:text-4xl lg:text-6xl shadow-md overflow-hidden rotate-[-3deg]'
                style={{ backgroundColor: bgColor }}
              >
                {targetUser?.img ? (
                  <img className='w-full h-full object-cover rounded-full' src={targetUser.img} alt="Profile" />
                ) : initial}
              </div>

              <div className='flex flex-col'>
                <h1 className='font-noto text-3xl sm:text-4xl lg:text-6xl font-bold text-[#323232] leading-tight'>
                  {targetUser.fullname}
                </h1>
                <div className='flex flex-col sm:flex-row sm:gap-4 mt-2 font-poppins text-gray-400 text-sm sm:text-lg uppercase tracking-widest font-medium'>
                  <span>{targetUser.country}</span>
                  <span className='hidden sm:inline opacity-30'>|</span>
                  <span>Since {memberSinceYear}</span>
                </div>
              </div>
            </div>

            <div className='grid grid-cols-2 gap-8 lg:gap-16 border-t lg:border-t-0 lg:border-l border-gray-100 pt-8 lg:pt-0 lg:pl-16'>
              <div className='flex flex-col'>
                <span className='font-staat text-5xl sm:text-6xl lg:text-8xl text-[#323232] leading-none'>
                  {reviewCount || 0}
                </span>
                <span className='font-staat text-[#42CDB4] text-lg sm:text-xl lg:text-2xl uppercase tracking-tighter mt-1'>
                  Total Reviews
                </span>
              </div>
              
              <div className='flex flex-col'>
                <span className='font-staat text-5xl sm:text-6xl lg:text-8xl text-[#323232] leading-none'>
                  {helpfulVotes || 0}
                </span>
                <span className='font-staat text-[#42CDB4] text-lg sm:text-xl lg:text-2xl uppercase tracking-tighter mt-1'>
                  Helpful Votes
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}